import React from "react";
import {BundlePrices} from "./BundleSummary";

export const BundleSummaryPrices: React.FC<BundlePrices> = ({UnitPrice, PromotionUnitPrice}) => {
    return (
        <>
            {!!PromotionUnitPrice ? (
                <div className={"pdp-bundle__bundle-price pdp-bundle__bundle-price--promo"}>
                    <span className={"regular"}>{UnitPrice}</span>
                    <span className={"promotion"}>{PromotionUnitPrice}</span>
                </div>
            ) : (
                <div className={"pdp-bundle__bundle-price"}>
                    <span className={"regular"}>{UnitPrice}</span>
                </div>
            )}
        </>
    )
}
